import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getProfile: () => client.get("/profile").then((r) => r.data),
  getServices: () => client.get("/services").then((r) => r.data),
  getService: (slug) => client.get(`/services/${slug}`).then((r) => r.data),
  getTechStacks: () => client.get("/tech-stacks").then((r) => r.data),
  getTechStack: (slug) => client.get(`/tech-stacks/${slug}`).then((r) => r.data),
  getProjects: () => client.get("/projects").then((r) => r.data),
  getProject: (slug) => client.get(`/projects/${slug}`).then((r) => r.data),
  getBlog: () => client.get("/blog").then((r) => r.data),
  getBlogPost: (slug) => client.get(`/blog/${slug}`).then((r) => r.data),
  createLead: (payload) => client.post("/leads", payload).then((r) => r.data),
};

export default api;
